import React, { useEffect, useState } from 'react';
import componentStyles from './registrationModal.module.css';
import globalStyles from '../globals.module.css';
import RegistrationSuggestionCard from './registrationSuggestionCard';
import { FaTimes } from 'react-icons/fa';

const RegistrationModal = ({ isOpen, onClose, title = 'Create Account', suggestionProps = {}, children = null }) => {
    const [isClosing, setIsClosing] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setIsClosing(false);
        } else if (shouldRender) {
            setIsClosing(true);
            const timer = setTimeout(() => {
                setShouldRender(false);
                setIsClosing(false);
            }, 300);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [isOpen, shouldRender]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setShouldRender(false);
            setIsClosing(false);
            onClose();
        }, 300);
    };

    if (!shouldRender && !isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    return (
        <div
            className={`${componentStyles.modalOverlay} ${isClosing ? componentStyles.modalOverlayClosing : componentStyles.modalOverlayOpening}`}
            onClick={handleOverlayClick}
        >
            <div className={`${componentStyles.modal} ${isClosing ? componentStyles.modalClosing : componentStyles.modalOpening}`}>
                <div className={componentStyles.modalHeader}>
                    <h2 className={componentStyles.modalTitle}>{title}</h2>
                    <button type="button" className={`${globalStyles.iconButton} ${globalStyles.squareButton}`} onClick={handleClose} aria-label="Close modal">
                        <FaTimes />
                    </button>
                </div>
                <div className={componentStyles.modalContent}>
                    {children || <RegistrationSuggestionCard {...suggestionProps} />}
                </div>
            </div>
        </div>
    );
};

export default RegistrationModal;
